// config.js
//export const BADART_URL = "https://dev.badart.app/api";
export const BADART_URL = "../api";